import { createEvent } from "$/util/db";
import CopyIcon from "@mui/icons-material/ContentCopy";
import FacebookIcon from "@mui/icons-material/Facebook";
import PinterestIcon from "@mui/icons-material/Pinterest";
import TwitterIcon from "@mui/icons-material/Twitter";
import WhatsappIcon from "@mui/icons-material/WhatsApp";
import {
  Dialog,
  DialogTitle,
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Snackbar,
  capitalize,
} from "@mui/material";
import React, { useState } from "react";
import {
  FacebookShareButton,
  PinterestShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share";
import analytics from "../util/analytics";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function SocialShareModal({ open, onClose, creation, variant, linkUrl, mediaUrl }) {
  const [clipboardOpen, setClipboardOpen] = useState(false);
  const shareUrl =
    linkUrl ||
    `${window.location.protocol}//${window.location.host}${window.location.pathname}${window.location.search}`;

  const shareButtons = [
    {
      name: "Pinterest",
      component: PinterestShareButton,
      icon: <PinterestIcon />,
      id: "pinterest",
    },
    {
      name: "Facebook",
      component: FacebookShareButton,
      icon: <FacebookIcon />,
      id: "facebook",
    },
    {
      name: "Twitter",
      component: TwitterShareButton,
      icon: <TwitterIcon />,
      id: "twitter",
    },
    {
      name: "WhatsApp",
      component: WhatsappShareButton,
      icon: <WhatsappIcon />,
      id: "whatsapp",
    },
  ];

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="share-modal-title"
      aria-describedby="share-modal-description"
    >
      <DialogTitle>Share on Socials</DialogTitle>
      <List sx={{ pt: 0, minWidth: 250 }}>
        {shareButtons.map((type, typeIdx) => (
          <React.Fragment key={type.name}>
            <ListItem>
              <ListItemButton
                component={type.component}
                style={{
                  padding: "8px 16px",
                  backgroundColor: "transparent",
                }}
                sx={{
                  "&:hover": {
                    backgroundColor: "rgba(0, 0, 0, 0.04) !important",
                  },
                }}
                url={shareUrl}
                media={type.id === "pinterest" ? mediaUrl : undefined}
                related={type.id === "twitter" ? ["BlackInkAI"] : undefined}
                title="Check out this design on BlackInk.AI!"
                windowWidth={800}
                windowHeight={600}
                description={
                  type.id === "pinterest"
                    ? `${capitalize(
                        creation.prompt,
                      )} tattoo idea created on BlackInk.AI!`
                    : undefined
                }
                onClick={() => {
                  analytics.track("share", {
                    platform: type.id,
                    creationId: creation.id,
                  });
                  createEvent("share", creation.id, variant);
                }}
              >
                <ListItemIcon>{type.icon}</ListItemIcon>
                <ListItemText primary={type.name} />
              </ListItemButton>
            </ListItem>
            <Divider variant="middle" component="li" />
          </React.Fragment>
        ))}
        <ListItem>
          <ListItemButton
            onClick={() => {
              analytics.track("share", {
                platform: "link",
                creationId: creation.id,
              });
              createEvent("share", creation.id, variant);
              navigator.clipboard.writeText(shareUrl);
              setClipboardOpen(true);
            }}
          >
            <ListItemIcon>
              <CopyIcon />
            </ListItemIcon>
            <ListItemText primary="Copy Link" />
          </ListItemButton>
        </ListItem>
      </List>

      <Snackbar
        open={clipboardOpen}
        autoHideDuration={2000}
        onClose={() => setClipboardOpen(false)}
        message="Link copied to clipboard"
      />
    </Dialog>
  );
}

export default SocialShareModal;
